import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0522dfda = () => interopDefault(import('../pages/affiliates.vue' /* webpackChunkName: "pages/affiliates" */))
const _0d6ab0b6 = () => interopDefault(import('../pages/agency-plans.vue' /* webpackChunkName: "pages/agency-plans" */))
const _6772f473 = () => interopDefault(import('../pages/analysis/index.vue' /* webpackChunkName: "pages/analysis/index" */))
const _0c3f75b6 = () => interopDefault(import('../pages/analytics/index.vue' /* webpackChunkName: "pages/analytics/index" */))
const _3e8adfbc = () => interopDefault(import('../pages/api-docs.vue' /* webpackChunkName: "pages/api-docs" */))
const _12f1648c = () => interopDefault(import('../pages/apply-promo.vue' /* webpackChunkName: "pages/apply-promo" */))
const _8ab580aa = () => interopDefault(import('../pages/automation.vue' /* webpackChunkName: "pages/automation" */))
const _5c5a4fb9 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _3e8cdac2 = () => interopDefault(import('../pages/campaigns/index.vue' /* webpackChunkName: "pages/campaigns/index" */))
const _84d2a678 = () => interopDefault(import('../pages/compare/index.vue' /* webpackChunkName: "pages/compare/index" */))
const _57f3fcbc = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _1e5a4c83 = () => interopDefault(import('../pages/content-library.vue' /* webpackChunkName: "pages/content-library" */))
const _1b61f830 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _42f6eca9 = () => interopDefault(import('../pages/dms/index.vue' /* webpackChunkName: "pages/dms/index" */))
const _bb23bed8 = () => interopDefault(import('../pages/features/index.vue' /* webpackChunkName: "pages/features/index" */))
const _e5377492 = () => interopDefault(import('../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _1e45c539 = () => interopDefault(import('../pages/import.vue' /* webpackChunkName: "pages/import" */))
const _2e3e30f6 = () => interopDefault(import('../pages/integrations/index.vue' /* webpackChunkName: "pages/integrations/index" */))
const _47c0ead0 = () => interopDefault(import('../pages/legal/index.vue' /* webpackChunkName: "pages/legal/index" */))
const _62f3dfbe = () => interopDefault(import('../pages/list-of-nsfw-subreddits.vue' /* webpackChunkName: "pages/list-of-nsfw-subreddits" */))
const _5fb0a6f6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _fc4226c4 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _038db850 = () => interopDefault(import('../pages/multi-social/index.vue' /* webpackChunkName: "pages/multi-social/index" */))
const _9601a1f4 = () => interopDefault(import('../pages/plans.vue' /* webpackChunkName: "pages/plans" */))
const _6223552a = () => interopDefault(import('../pages/reddit-wrapped.vue' /* webpackChunkName: "pages/reddit-wrapped" */))
const _42052c9d = () => interopDefault(import('../pages/safety-letter.vue' /* webpackChunkName: "pages/safety-letter" */))
const _1a9bd0fa = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _fdb05da8 = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _89da128a = () => interopDefault(import('../pages/stats.vue' /* webpackChunkName: "pages/stats" */))
const _5485b206 = () => interopDefault(import('../pages/submissions/index.vue' /* webpackChunkName: "pages/submissions/index" */))
const _4f796228 = () => interopDefault(import('../pages/subreddits/index.vue' /* webpackChunkName: "pages/subreddits/index" */))
const _09eb6f1f = () => interopDefault(import('../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _554b02fe = () => interopDefault(import('../pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _3d4212f3 = () => interopDefault(import('../pages/analysis/redditors.vue' /* webpackChunkName: "pages/analysis/redditors" */))
const _888442f6 = () => interopDefault(import('../pages/analytics/instagram.vue' /* webpackChunkName: "pages/analytics/instagram" */))
const _f68568f4 = () => interopDefault(import('../pages/analytics/twitter.vue' /* webpackChunkName: "pages/analytics/twitter" */))
const _8a7a6f88 = () => interopDefault(import('../pages/campaigns/create.vue' /* webpackChunkName: "pages/campaigns/create" */))
const _5633fde8 = () => interopDefault(import('../pages/catch/imgur.vue' /* webpackChunkName: "pages/catch/imgur" */))
const _5f9c677a = () => interopDefault(import('../pages/compare/postpone-vs-delay-for-reddit.vue' /* webpackChunkName: "pages/compare/postpone-vs-delay-for-reddit" */))
const _3928dd7b = () => interopDefault(import('../pages/compare/postpone-vs-fancharm.vue' /* webpackChunkName: "pages/compare/postpone-vs-fancharm" */))
const _12d0701a = () => interopDefault(import('../pages/compare/postpone-vs-later-for-reddit.vue' /* webpackChunkName: "pages/compare/postpone-vs-later-for-reddit" */))
const _3c274ea2 = () => interopDefault(import('../pages/compare/postpone-vs-social-rise.vue' /* webpackChunkName: "pages/compare/postpone-vs-social-rise" */))
const _439af335 = () => interopDefault(import('../pages/dms/create.vue' /* webpackChunkName: "pages/dms/create" */))
const _2b8a2746 = () => interopDefault(import('../pages/dms/inbox.vue' /* webpackChunkName: "pages/dms/inbox" */))
const _0526bf3f = () => interopDefault(import('../pages/features/bulk-import-reddit-posts.vue' /* webpackChunkName: "pages/features/bulk-import-reddit-posts" */))
const _626ba7ae = () => interopDefault(import('../pages/features/content-library.vue' /* webpackChunkName: "pages/features/content-library" */))
const _61416643 = () => interopDefault(import('../pages/features/direct-message-automation.vue' /* webpackChunkName: "pages/features/direct-message-automation" */))
const _4d1c5ce6 = () => interopDefault(import('../pages/features/multiple-reddit-accounts.vue' /* webpackChunkName: "pages/features/multiple-reddit-accounts" */))
const _ace0b3fa = () => interopDefault(import('../pages/features/reddit-account-safety.vue' /* webpackChunkName: "pages/features/reddit-account-safety" */))
const _d391bab0 = () => interopDefault(import('../pages/features/reddit-automation.vue' /* webpackChunkName: "pages/features/reddit-automation" */))
const _4a9332ac = () => interopDefault(import('../pages/features/reddit-post-analytics.vue' /* webpackChunkName: "pages/features/reddit-post-analytics" */))
const _212d7cdd = () => interopDefault(import('../pages/features/reddit-post-templates.vue' /* webpackChunkName: "pages/features/reddit-post-templates" */))
const _031646dc = () => interopDefault(import('../pages/features/schedule-reddit-posts.vue' /* webpackChunkName: "pages/features/schedule-reddit-posts" */))
const _367d834e = () => interopDefault(import('../pages/features/subreddit-analysis.vue' /* webpackChunkName: "pages/features/subreddit-analysis" */))
const _2807e780 = () => interopDefault(import('../pages/features/subreddit-manager.vue' /* webpackChunkName: "pages/features/subreddit-manager" */))
const _3c530730 = () => interopDefault(import('../pages/instagram/schedule.vue' /* webpackChunkName: "pages/instagram/schedule" */))
const _ca383264 = () => interopDefault(import('../pages/legal/privacy.vue' /* webpackChunkName: "pages/legal/privacy" */))
const _2d553c7e = () => interopDefault(import('../pages/legal/refunds.vue' /* webpackChunkName: "pages/legal/refunds" */))
const _f3c56e66 = () => interopDefault(import('../pages/legal/terms.vue' /* webpackChunkName: "pages/legal/terms" */))
const _585a25cc = () => interopDefault(import('../pages/posts/create.vue' /* webpackChunkName: "pages/posts/create" */))
const _dfe0ea34 = () => interopDefault(import('../pages/posts/inbox.vue' /* webpackChunkName: "pages/posts/inbox" */))
const _2253a21e = () => interopDefault(import('../pages/settings/accounts/index.vue' /* webpackChunkName: "pages/settings/accounts/index" */))
const _206bb9c7 = () => interopDefault(import('../pages/settings/change-email.vue' /* webpackChunkName: "pages/settings/change-email" */))
const _072ff140 = () => interopDefault(import('../pages/settings/change-password.vue' /* webpackChunkName: "pages/settings/change-password" */))
const _a829b064 = () => interopDefault(import('../pages/settings/checklist.vue' /* webpackChunkName: "pages/settings/checklist" */))
const _315eef68 = () => interopDefault(import('../pages/settings/custom-schedules.vue' /* webpackChunkName: "pages/settings/custom-schedules" */))
const _79e17184 = () => interopDefault(import('../pages/settings/danger-zone.vue' /* webpackChunkName: "pages/settings/danger-zone" */))
const _1b6defbc = () => interopDefault(import('../pages/settings/export.vue' /* webpackChunkName: "pages/settings/export" */))
const _6d9f91a8 = () => interopDefault(import('../pages/settings/manage-users.vue' /* webpackChunkName: "pages/settings/manage-users" */))
const _2a07b210 = () => interopDefault(import('../pages/settings/notifications.vue' /* webpackChunkName: "pages/settings/notifications" */))
const _623053d8 = () => interopDefault(import('../pages/settings/post-settings.vue' /* webpackChunkName: "pages/settings/post-settings" */))
const _1f0c0eb4 = () => interopDefault(import('../pages/settings/proxies.vue' /* webpackChunkName: "pages/settings/proxies" */))
const _2467f6b6 = () => interopDefault(import('../pages/settings/subscription.vue' /* webpackChunkName: "pages/settings/subscription" */))
const _3a2ff2e6 = () => interopDefault(import('../pages/submissions/instagram.vue' /* webpackChunkName: "pages/submissions/instagram" */))
const _6889f7b2 = () => interopDefault(import('../pages/submissions/twitter.vue' /* webpackChunkName: "pages/submissions/twitter" */))
const _f2e64118 = () => interopDefault(import('../pages/subreddits/recommendations.vue' /* webpackChunkName: "pages/subreddits/recommendations" */))
const _7b13ca47 = () => interopDefault(import('../pages/twitter/schedule.vue' /* webpackChunkName: "pages/twitter/schedule" */))
const _28202949 = () => interopDefault(import('../pages/use-cases/agencies.vue' /* webpackChunkName: "pages/use-cases/agencies" */))
const _5110ec81 = () => interopDefault(import('../pages/use-cases/content-creators.vue' /* webpackChunkName: "pages/use-cases/content-creators" */))
const _8fe8149a = () => interopDefault(import('../pages/use-cases/fansly.vue' /* webpackChunkName: "pages/use-cases/fansly" */))
const _37079613 = () => interopDefault(import('../pages/use-cases/kickstarter.vue' /* webpackChunkName: "pages/use-cases/kickstarter" */))
const _52d83ed2 = () => interopDefault(import('../pages/use-cases/onlyfans.vue' /* webpackChunkName: "pages/use-cases/onlyfans" */))
const _a7b78002 = () => interopDefault(import('../pages/use-cases/patreon.vue' /* webpackChunkName: "pages/use-cases/patreon" */))
const _155cf62e = () => interopDefault(import('../pages/use-cases/youtubers.vue' /* webpackChunkName: "pages/use-cases/youtubers" */))
const _0cd20251 = () => interopDefault(import('../pages/settings/accounts/instagram.vue' /* webpackChunkName: "pages/settings/accounts/instagram" */))
const _4d058a9f = () => interopDefault(import('../pages/settings/accounts/redgifs.vue' /* webpackChunkName: "pages/settings/accounts/redgifs" */))
const _13dff252 = () => interopDefault(import('../pages/settings/accounts/twitter.vue' /* webpackChunkName: "pages/settings/accounts/twitter" */))
const _9000a8d4 = () => interopDefault(import('../pages/settings/billing/cancel.vue' /* webpackChunkName: "pages/settings/billing/cancel" */))
const _644e6284 = () => interopDefault(import('../pages/blog/post/_slug.vue' /* webpackChunkName: "pages/blog/post/_slug" */))
const _4c9456ce = () => interopDefault(import('../pages/confirm-email/_token.vue' /* webpackChunkName: "pages/confirm-email/_token" */))
const _5c0782d4 = () => interopDefault(import('../pages/connect/_token/index.vue' /* webpackChunkName: "pages/connect/_token/index" */))
const _32c1280c = () => interopDefault(import('../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _20f149a0 = () => interopDefault(import('../pages/subreddits/_subredditName.vue' /* webpackChunkName: "pages/subreddits/_subredditName" */))
const _442c2ba8 = () => interopDefault(import('../pages/subscribe/_planCode.vue' /* webpackChunkName: "pages/subscribe/_planCode" */))
const _0c10db8a = () => interopDefault(import('../pages/connect/_token/invalid.vue' /* webpackChunkName: "pages/connect/_token/invalid" */))
const _31a20b72 = () => interopDefault(import('../pages/connect/_token/success.vue' /* webpackChunkName: "pages/connect/_token/success" */))
const _222e1483 = () => interopDefault(import('../pages/join/_token/invalid.vue' /* webpackChunkName: "pages/join/_token/invalid" */))
const _0680096e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/affiliates",
    component: _0522dfda,
    name: "affiliates"
  }, {
    path: "/agency-plans",
    component: _0d6ab0b6,
    name: "agency-plans"
  }, {
    path: "/analysis",
    component: _6772f473,
    name: "analysis"
  }, {
    path: "/analytics",
    component: _0c3f75b6,
    name: "analytics"
  }, {
    path: "/api-docs",
    component: _3e8adfbc,
    name: "api-docs"
  }, {
    path: "/apply-promo",
    component: _12f1648c,
    name: "apply-promo"
  }, {
    path: "/automation",
    component: _8ab580aa,
    name: "automation"
  }, {
    path: "/blog",
    component: _5c5a4fb9,
    name: "blog"
  }, {
    path: "/campaigns",
    component: _3e8cdac2,
    name: "campaigns"
  }, {
    path: "/compare",
    component: _84d2a678,
    name: "compare"
  }, {
    path: "/contact",
    component: _57f3fcbc,
    name: "contact"
  }, {
    path: "/content-library",
    component: _1e5a4c83,
    name: "content-library"
  }, {
    path: "/dashboard",
    component: _1b61f830,
    name: "dashboard"
  }, {
    path: "/dms",
    component: _42f6eca9,
    name: "dms"
  }, {
    path: "/features",
    component: _bb23bed8,
    name: "features"
  }, {
    path: "/forgot",
    component: _e5377492,
    name: "forgot"
  }, {
    path: "/import",
    component: _1e45c539,
    name: "import"
  }, {
    path: "/integrations",
    component: _2e3e30f6,
    name: "integrations"
  }, {
    path: "/legal",
    component: _47c0ead0,
    name: "legal"
  }, {
    path: "/list-of-nsfw-subreddits",
    component: _62f3dfbe,
    name: "list-of-nsfw-subreddits"
  }, {
    path: "/login",
    component: _5fb0a6f6,
    name: "login"
  }, {
    path: "/logout",
    component: _fc4226c4,
    name: "logout"
  }, {
    path: "/multi-social",
    component: _038db850,
    name: "multi-social"
  }, {
    path: "/plans",
    component: _9601a1f4,
    name: "plans"
  }, {
    path: "/reddit-wrapped",
    component: _6223552a,
    name: "reddit-wrapped"
  }, {
    path: "/safety-letter",
    component: _42052c9d,
    name: "safety-letter"
  }, {
    path: "/settings",
    component: _1a9bd0fa,
    name: "settings"
  }, {
    path: "/signup",
    component: _fdb05da8,
    name: "signup"
  }, {
    path: "/stats",
    component: _89da128a,
    name: "stats"
  }, {
    path: "/submissions",
    component: _5485b206,
    name: "submissions"
  }, {
    path: "/subreddits",
    component: _4f796228,
    name: "subreddits"
  }, {
    path: "/success",
    component: _09eb6f1f,
    name: "success"
  }, {
    path: "/welcome",
    component: _554b02fe,
    name: "welcome"
  }, {
    path: "/analysis/redditors",
    component: _3d4212f3,
    name: "analysis:redditors"
  }, {
    path: "/analytics/instagram",
    component: _888442f6,
    name: "analytics:instagram"
  }, {
    path: "/analytics/twitter",
    component: _f68568f4,
    name: "analytics:twitter"
  }, {
    path: "/campaigns/create",
    component: _8a7a6f88,
    name: "campaigns:create"
  }, {
    path: "/catch/imgur",
    component: _5633fde8,
    name: "catch:imgur"
  }, {
    path: "/compare/postpone-vs-delay-for-reddit",
    component: _5f9c677a,
    name: "compare:postpone-vs-delay-for-reddit"
  }, {
    path: "/compare/postpone-vs-fancharm",
    component: _3928dd7b,
    name: "compare:postpone-vs-fancharm"
  }, {
    path: "/compare/postpone-vs-later-for-reddit",
    component: _12d0701a,
    name: "compare:postpone-vs-later-for-reddit"
  }, {
    path: "/compare/postpone-vs-social-rise",
    component: _3c274ea2,
    name: "compare:postpone-vs-social-rise"
  }, {
    path: "/dms/create",
    component: _439af335,
    name: "dms:create"
  }, {
    path: "/dms/inbox",
    component: _2b8a2746,
    name: "dms:inbox"
  }, {
    path: "/features/bulk-import-reddit-posts",
    component: _0526bf3f,
    name: "features:bulk-import-reddit-posts"
  }, {
    path: "/features/content-library",
    component: _626ba7ae,
    name: "features:content-library"
  }, {
    path: "/features/direct-message-automation",
    component: _61416643,
    name: "features:direct-message-automation"
  }, {
    path: "/features/multiple-reddit-accounts",
    component: _4d1c5ce6,
    name: "features:multiple-reddit-accounts"
  }, {
    path: "/features/reddit-account-safety",
    component: _ace0b3fa,
    name: "features:reddit-account-safety"
  }, {
    path: "/features/reddit-automation",
    component: _d391bab0,
    name: "features:reddit-automation"
  }, {
    path: "/features/reddit-post-analytics",
    component: _4a9332ac,
    name: "features:reddit-post-analytics"
  }, {
    path: "/features/reddit-post-templates",
    component: _212d7cdd,
    name: "features:reddit-post-templates"
  }, {
    path: "/features/schedule-reddit-posts",
    component: _031646dc,
    name: "features:schedule-reddit-posts"
  }, {
    path: "/features/subreddit-analysis",
    component: _367d834e,
    name: "features:subreddit-analysis"
  }, {
    path: "/features/subreddit-manager",
    component: _2807e780,
    name: "features:subreddit-manager"
  }, {
    path: "/instagram/schedule",
    component: _3c530730,
    name: "instagram:schedule"
  }, {
    path: "/legal/privacy",
    component: _ca383264,
    name: "legal:privacy"
  }, {
    path: "/legal/refunds",
    component: _2d553c7e,
    name: "legal:refunds"
  }, {
    path: "/legal/terms",
    component: _f3c56e66,
    name: "legal:terms"
  }, {
    path: "/posts/create",
    component: _585a25cc,
    name: "posts:create"
  }, {
    path: "/posts/inbox",
    component: _dfe0ea34,
    name: "posts:inbox"
  }, {
    path: "/settings/accounts",
    component: _2253a21e,
    name: "settings:accounts"
  }, {
    path: "/settings/change-email",
    component: _206bb9c7,
    name: "settings:change-email"
  }, {
    path: "/settings/change-password",
    component: _072ff140,
    name: "settings:change-password"
  }, {
    path: "/settings/checklist",
    component: _a829b064,
    name: "settings:checklist"
  }, {
    path: "/settings/custom-schedules",
    component: _315eef68,
    name: "settings:custom-schedules"
  }, {
    path: "/settings/danger-zone",
    component: _79e17184,
    name: "settings:danger-zone"
  }, {
    path: "/settings/export",
    component: _1b6defbc,
    name: "settings:export"
  }, {
    path: "/settings/manage-users",
    component: _6d9f91a8,
    name: "settings:manage-users"
  }, {
    path: "/settings/notifications",
    component: _2a07b210,
    name: "settings:notifications"
  }, {
    path: "/settings/post-settings",
    component: _623053d8,
    name: "settings:post-settings"
  }, {
    path: "/settings/proxies",
    component: _1f0c0eb4,
    name: "settings:proxies"
  }, {
    path: "/settings/subscription",
    component: _2467f6b6,
    name: "settings:subscription"
  }, {
    path: "/submissions/instagram",
    component: _3a2ff2e6,
    name: "submissions:instagram"
  }, {
    path: "/submissions/twitter",
    component: _6889f7b2,
    name: "submissions:twitter"
  }, {
    path: "/subreddits/recommendations",
    component: _f2e64118,
    name: "subreddits:recommendations"
  }, {
    path: "/twitter/schedule",
    component: _7b13ca47,
    name: "twitter:schedule"
  }, {
    path: "/use-cases/agencies",
    component: _28202949,
    name: "use-cases:agencies"
  }, {
    path: "/use-cases/content-creators",
    component: _5110ec81,
    name: "use-cases:content-creators"
  }, {
    path: "/use-cases/fansly",
    component: _8fe8149a,
    name: "use-cases:fansly"
  }, {
    path: "/use-cases/kickstarter",
    component: _37079613,
    name: "use-cases:kickstarter"
  }, {
    path: "/use-cases/onlyfans",
    component: _52d83ed2,
    name: "use-cases:onlyfans"
  }, {
    path: "/use-cases/patreon",
    component: _a7b78002,
    name: "use-cases:patreon"
  }, {
    path: "/use-cases/youtubers",
    component: _155cf62e,
    name: "use-cases:youtubers"
  }, {
    path: "/settings/accounts/instagram",
    component: _0cd20251,
    name: "settings:accounts:instagram"
  }, {
    path: "/settings/accounts/redgifs",
    component: _4d058a9f,
    name: "settings:accounts:redgifs"
  }, {
    path: "/settings/accounts/twitter",
    component: _13dff252,
    name: "settings:accounts:twitter"
  }, {
    path: "/settings/billing/cancel",
    component: _9000a8d4,
    name: "settings:billing:cancel"
  }, {
    path: "/blog/post/:slug?",
    component: _644e6284,
    name: "blog:post:slug"
  }, {
    path: "/confirm-email/:token?",
    component: _4c9456ce,
    name: "confirm-email:token"
  }, {
    path: "/connect/:token",
    component: _5c0782d4,
    name: "connect:token"
  }, {
    path: "/reset-password/:token?",
    component: _32c1280c,
    name: "reset-password:token"
  }, {
    path: "/subreddits/:subredditName",
    component: _20f149a0,
    name: "subreddits:subredditName"
  }, {
    path: "/subscribe/:planCode?",
    component: _442c2ba8,
    name: "subscribe:planCode"
  }, {
    path: "/connect/:token?/invalid",
    component: _0c10db8a,
    name: "connect:token:invalid"
  }, {
    path: "/connect/:token?/success",
    component: _31a20b72,
    name: "connect:token:success"
  }, {
    path: "/join/:token?/invalid",
    component: _222e1483,
    name: "join:token:invalid"
  }, {
    path: "/",
    component: _0680096e,
    name: "index"
  }, {
    path: "/posts/edit/:postId",
    component: _585a25cc,
    props: true,
    name: "posts:edit"
  }, {
    path: "/twitter/schedule/:postId",
    component: _7b13ca47,
    props: true,
    name: "twitter:edit"
  }, {
    path: "/instagram/schedule/:postId",
    component: _3c530730,
    props: true,
    name: "instagram:edit"
  }, {
    path: "/dms/edit/:dmId",
    component: _439af335,
    props: true,
    name: "dms:edit"
  }, {
    path: "/campaigns/edit/:campaignId",
    component: _8a7a6f88,
    props: true,
    name: "campaigns:edit"
  }, {
    path: "/analysis/subreddit/:subredditName",
    component: _6772f473,
    props: true,
    name: "analysis:name"
  }, {
    path: "/analysis/redditors/:username",
    component: _3d4212f3,
    props: true,
    name: "redditors:name"
  }, {
    path: "/signin",
    component: _5fb0a6f6,
    meta: {"redirect":true}
  }, {
    path: "/terms",
    component: _f3c56e66,
    meta: {"redirect":true}
  }, {
    path: "/privacy",
    component: _ca383264,
    meta: {"redirect":true}
  }, {
    path: "/refunds",
    component: _2d553c7e,
    meta: {"redirect":true}
  }, {
    path: "/features/analysis",
    component: _367d834e,
    meta: {"redirect":true}
  }, {
    path: "/features/analytics",
    component: _4a9332ac,
    meta: {"redirect":true}
  }, {
    path: "/features/automation",
    component: _d391bab0,
    meta: {"redirect":true}
  }, {
    path: "/features/campaigns",
    component: _212d7cdd,
    meta: {"redirect":true}
  }, {
    path: "/features/direct-messages",
    component: _61416643,
    meta: {"redirect":true}
  }, {
    path: "/features/import",
    component: _0526bf3f,
    meta: {"redirect":true}
  }, {
    path: "/features/safety",
    component: _ace0b3fa,
    meta: {"redirect":true}
  }, {
    path: "/features/schedule",
    component: _031646dc,
    meta: {"redirect":true}
  }, {
    path: "/settings",
    component: _1a9bd0fa,
    meta: {"redirect":true}
  }, {
    path: "/profile",
    component: _1a9bd0fa,
    meta: {"redirect":true}
  }, {
    path: "/profile/accounts",
    component: _2253a21e,
    meta: {"redirect":true}
  }, {
    path: "/profile/notifications",
    component: _2a07b210,
    meta: {"redirect":true}
  }, {
    path: "/profile/change-email",
    component: _206bb9c7,
    meta: {"redirect":true}
  }, {
    path: "/profile/change-password",
    component: _072ff140,
    meta: {"redirect":true}
  }, {
    path: "/profile/checklist",
    component: _a829b064,
    meta: {"redirect":true}
  }, {
    path: "/profile/post-settings",
    component: _623053d8,
    meta: {"redirect":true}
  }, {
    path: "/profile/subscription",
    component: _2467f6b6,
    meta: {"redirect":true}
  }, {
    path: "/profile/billing/cancel",
    component: _9000a8d4,
    meta: {"redirect":true}
  }, {
    path: "/help",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/';
        }
  }, {
    path: "/help/bulk-importing",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/bulk-import';
        }
  }, {
    path: "/help/linking-accounts",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/help/linking-additional-reddit-accounts';
        }
  }, {
    path: "/help/post-templates",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/scheduling-posts/post-templates';
        }
  }, {
    path: "/help/rate-limits",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/help/rate-limits';
        }
  }, {
    path: "/api-docs",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/api-docs/postpone-api';
        }
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
